<div class="toolbox_plate"
     *ngIf="this.permissionService.hasPermission('ID_VEICULO_BOTAO_FUNCAO', this.permissions)">
  <mat-button-toggle-group
    name="plate"
    [multiple]="true"
    (change)="toggleView($event)"
  >
    <mat-button-toggle value="show_plate">
      <mat-icon>room</mat-icon>
      <span class="btn-icon-text">ID Veículo</span>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
